import React from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import Menu from '@iso/components/uielements/menu';
import IntlMessages from '@iso/components/utility/intlMessages';
import { hiddenKeys, hasPlanAccess } from './hiddenKeys';
const SubMenu = Menu.SubMenu;

const stripTrailingSlash = str => {
  if (str.substr(-1) === '/') {
    return str.substr(0, str.length - 1);
  }
  return str;
};



export default React.memo(function SidebarMenu({
  singleOption,
  submenuStyle,
  submenuColor,
  stripePlan,
  ...rest
}) {

  let match = useRouteMatch();
  const activePropertySubscription = useSelector((state) => state.subscription.activePropertySubscription);

  const { key, label, leftIcon, children, linkTo } = singleOption;
  const url = stripTrailingSlash(match.url);

  if (children ) {
    const titleContent = (
      <span className="isoMenuHolder" style={submenuColor}>
        {leftIcon}
        <span className="nav-text">
          <IntlMessages id={label} />
        </span>
      </span>
    );
    return (
      <SubMenu
        key={key}
        // When `linkTo` is set the title is a Link so clicking the parent
        // navigates (while the dropdown arrow still expands the submenu).
        title={
          linkTo ? (
            <Link style={submenuColor} to={linkTo}>
              {titleContent}
            </Link>
          ) : (
            titleContent
          )
        }
        {...rest}
      >
        {children.map(child => {
          const childLinkTo = child.withoutDashboard
            ? `/${child.key}`
            : `${url}/${child.key}`;
          return (
            <Menu.Item style={submenuStyle} key={child.key}>
              <Link style={submenuColor} to={childLinkTo}>
                <IntlMessages id={child.label} />
              </Link>
            </Menu.Item>
          );
        })}
      </SubMenu>
    );
  }
  // rc-menu indents items inside a SubMenu via a computed inline
  // paddingLeft (level * 24). Our group dropdowns should list items flush
  // with the top-level entries, so pin the padding to the level-1 value.
  const flushLeft = { ...(rest.style || {}), paddingLeft: 24 };

  if(! hiddenKeys().includes(key)){
    return (
      <Menu.Item key={key} {...rest} style={flushLeft}>
      {
        <Link to={`${url}/${key}`} id="custom-menu-icon">
          <span className="isoMenuHolder" style={submenuColor}>    
            {leftIcon}
            <span className="nav-text">
              <IntlMessages id={label} />
            </span>
          </span>
        </Link>
      }
      </Menu.Item>
    );
  }else{
      if(hasPlanAccess(key, activePropertySubscription)){

        return (
          <Menu.Item key={key} {...rest} style={flushLeft}>

            <Link to={`${url}/${key}`} id="custom-menu-icon">
              <span className="isoMenuHolder" style={submenuColor}>    
                {leftIcon}
                <span className="nav-text">
                  <IntlMessages id={label} />
                </span>
              </span>
            </Link>
          </Menu.Item>
        
        );
      }
    
 
  }
    
  


});
